import { inject } from '../utils';

class SessionService {
  constructor(store) {
    this.store = store;
  }

  getAffiliateId() {
    const {
      session: {
        affiliateId,
      },
    } = this.store.getState();

    return affiliateId;
  }

  getAffiliateTimezone() {
    const {
      session: {
        affiliate: {
          attributes: {
            timezone,
          },
        },
      },
    } = this.store.getState();

    return timezone;
  }

  getAccessToken() {
    const {
      session: {
        accessToken,
      },
    } = this.store.getState();

    return accessToken;
  }

  getAffiliateConfig() {
    const {
      session: {
        affiliate: {
          attributes: {
            config,
          },
        },
      },
    } = this.store.getState();

    return config;
  }

  getAffiliateName() {
    const {
      session: {
        affiliate: {
          attributes: {
            name,
          },
        },
      },
    } = this.store.getState();

    return name;
  }

  getUser() {
    const {
      session: {
        user,
      },
    } = this.store.getState();

    return {
      user,
    };
  }
}

inject(SessionService, ['Store']);
export default SessionService;



// WEBPACK FOOTER //
// ./src/services/SessionService.js